import { useGenomeViewerStore } from "../../../store/store.ts";
import { MIN_TRACKGROUP_WIDTH } from "../settings.ts";

export function useGroupWidth(groupId: string, scale: number): number {
  const basePerPixel = useGenomeViewerStore((state) => state.basePerPixel);
  const trackGroupLength = useGenomeViewerStore((state) => state.trackGroups.get(groupId)?.graphics.length ?? 0);

  // subtract stroke width on the left and right (is always outer in svg)
  // avoid negative width but allow rect to be 0px wide
  return Math.max((trackGroupLength / basePerPixel) * scale, MIN_TRACKGROUP_WIDTH);
}
